// extracted by mini-css-extract-plugin
module.exports = {"articleSelect":"FilterContainerDark_articleSelect__3tRZ8","articleSelectTitle":"FilterContainerDark_articleSelectTitle__1KjPy"};